import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { styled } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const FormContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh"
});

const Form = styled("form")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  width: "320px",
  maxWidth: "90vw",
  padding: "12px",
  boxSizing: "border-box"
});

const TextFieldStyled = styled(TextField)({
  width: "320px"
});

const ButtonStyled = styled(Button)({
  width: "200px"
});


const SimpleRegister = registerType => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async e => {
    e.preventDefault();

    if (!username || username.trim() === "") {
      setErrorMessage("אנא הזן שם משתמש.");
      return;
    }

    try {
      setErrorMessage("");
      // Send registration data to the server
      const response = await fetch(
        `/api/${registerType.registerType}/register`,
        {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ username, password })
        }
      );

      const data = await response.json();

      if (response.ok && data.message === "Registration successful") {
        const cookie = data.cookie;
        // Store cookie and username in localStorage so auth validation can find them
        localStorage.setItem("cookie", cookie);
        localStorage.setItem("username", username);
        console.log(`Set username='${username}', cookie='${cookie}'`);

        navigate(`/${registerType.registerType}/manager`); // Redirect to the success page
      } else {
        // Show server-provided message or a generic failure message
        setErrorMessage(data.message || "הרשמה נכשלה. אנא נסה שוב.");
      }
    } catch (error) {
      console.log(error);
      setErrorMessage("שגיאת רשת, אנא נסה שוב.");
    }
  };

  return (
    <FormContainer>
      <h1>הרשמה</h1>
      {errorMessage && (
        <Alert
          severity="error"
          sx={{
            width: '324px',
            marginBottom: 2.5,
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            maxHeight: '6em',
            overflowY: 'auto',
            boxShadow: '0 1px 6px rgba(0,0,0,0.12)'
          }}
        >
          {errorMessage}
        </Alert>
      )}
      <Form onSubmit={handleSubmit}>
        <TextFieldStyled
          label="Username"
          variant="outlined"
          value={username}
          onChange={e => {
            setUsername(e.target.value);
            if (errorMessage) setErrorMessage("");
          }}
        />
        <TextFieldStyled
          label="Password"
          variant="outlined"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <ButtonStyled
          type="submit"
          variant="contained"
          color="primary"
          disabled={!username.trim()}
        >
          Register
        </ButtonStyled>
      </Form>
    </FormContainer>
  );
};

export default SimpleRegister;
